import * as actions from 'actions';

const INITIAL_STATE = {
  page: 0,
  totalCount: 0,
  isFetching: false,
  hasFetchedManually: false
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.FEED_FETCH: {
      const newPage = action.page || state.page;
      return {
        ...state,
        isFetching: true,
        page: newPage
      };
    }

    case actions.FEED_RECEIVED: {
      return {
        ...state,
        isFetching: false,
        totalCount: action.result.meta.count,
        hasFetchedManually: action.isManualFetch
      };
    }

    case actions.FEED_FETCH_ERROR: {
      return {
        ...state,
        isFetching: false
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/paging/reducer.js
 **/